<template>
  <div>
    <editable-chart-title v-if="printable" v-model="reportTitle"></editable-chart-title>
    <highcharts :options="options" ref="highcharts" />
  </div>
</template>

<script>
import Highcharts from 'highcharts';
import ExportingHighcharts from 'highcharts/modules/exporting';
import { Chart } from 'highcharts-vue';
import printableChart from './printableChart';

ExportingHighcharts(Highcharts);

export default {
  name: 'donut-chart',
  mixins: [printableChart],
  props: {
    outerLevel: Array,
    innerLevel: Array,
    title: String,
    outerLevelName: String,
    innerLevelName: String,
  },
  watch: {
    // HCI-4741: update the options, not the chart. highcharts-vue sends the
    // options to `chart.update()` with `oneToOne`, so the chart data must live
    // in `chartOptions`. A chart built straight from the chart object would
    // lose all its data on the next options change.
    outerLevel(val) {
      this.chartOptions.series[1].data = val;
    },
    innerLevel(val) {
      this.chartOptions.series[0].data = val;
    }
  },
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      chartOptions: {
        chart: {
          type: 'pie',
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0
          }
        },
        title: {
          text: this.title
        },
        plotOptions: {
          pie: {
            depth: 45,
            dataLabels: {
              enabled: true,
              format: '{point.name}: <b>{point.percentage:.1f}%</b>'
            }
          }
        },
        series: [{
          name: this.innerLevelName,
          data: this.innerLevel,
          size: '45%',
          dataLabels: {
            color: '#ffffff',
            distance: '-50%'
          }
        }, {
          name: this.outerLevelName,
          data: this.outerLevel,
          size: '80%',
          innerSize: '60%',
          dataLabels: {
            style: {
              fontWeight: 'normal'
            }
          },
        }],
        credits: {
          enabled: false
        },
        responsive: {
          rules: [{
            condition: {
              maxWidth: 400
            },
            chartOptions: {
              series: [{
              }, {
                dataLabels: {
                  distance: 10,
                  format: '{point.custom.version}',
                }
              }]
            }
          }]
        }
      }
    };
  },
  computed: {
    options() {
      return this.applyPrintableTitle(this.chartOptions);
    },
  },
};
</script>